import { gql } from '@apollo/client'

export const CANCEL_CLOSING_INFO_EMAIL_MUTATION = gql`
  mutation cancelClosingInfoEmail($closingInfoEmailActionId: ID!) {
    cancelClosingInfoEmail(closingInfoEmailActionId: $closingInfoEmailActionId) {
      id
      cancelled
      closingInfoEmailCancelledAt
    }
  }
`
